(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-foot-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-foot-hero')) {
    customElements.define('lf-foot-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.buttons = Array.from(this.querySelectorAll('button[aria-controls]'));
        this.buttons.forEach((btn) => btn.addEventListener('click', () => this.toggle(btn)));
      }
      toggle(current) {
        const open = current.getAttribute('aria-expanded') !== 'true';
        let shown = null;
        this.buttons.forEach((btn) => {
          const on = open && btn === current;
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; if (on) shown = panel; }
        });
        if (shown) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          shown.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-foot-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-foot-selector')) {
    customElements.define('lf-foot-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            const last = this.tabs.length - 1;
            let next;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = last;
            else return;
            e.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-foot-solutions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-foot-solutions')) {
    customElements.define('lf-foot-solutions', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('change', (e) => {
          const input = e.target;
          if (!input.matches('input[type="radio"]')) return;
          const status = this.querySelector('[data-status]');
          if (!status) return;
          const cards = this.querySelectorAll('[data-category]');
          const n = Array.from(cards).filter((c) => input.value === 'all' || c.dataset.category === input.value).length;
          const label = input.nextElementSibling ? input.nextElementSibling.textContent.trim() : input.value;
          status.textContent = (this.dataset.statusTemplate || '[count] shown').replace('[count]', n).replace('[filter]', label);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-search-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-search-bar')) {
    class LfSearchBar extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        if (this.dataset.live !== 'true' || !this.input || !this.results) return;
        this.last = '';
        this.onInput = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(), 300);
        };
        this.onKey = (e) => this.keydown(e);
        this.onFocusOut = (e) => {
          if (!this.contains(e.relatedTarget)) this.close();
        };
        this.onReset = () => {
          this.last = '';
          this.close();
          this.status.textContent = '';
        };
        this.input.addEventListener('input', this.onInput);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('focusout', this.onFocusOut);
        this.input.form.addEventListener('reset', this.onReset);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.ctrl) this.ctrl.abort();
      }

      async search() {
        const q = this.input.value.trim();
        if (q.length < 2) {
          this.last = '';
          this.close();
          return;
        }
        if (q === this.last) {
          this.open();
          return;
        }
        this.last = q;
        if (this.ctrl) this.ctrl.abort();
        this.ctrl = new AbortController();
        this.message(this.dataset.loading);
        this.status.textContent = this.dataset.loading;
        try {
          const url = this.dataset.url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
          const res = await fetch(url, { signal: this.ctrl.signal });
          if (!res.ok) throw new Error(String(res.status));
          const data = await res.json();
          this.render((data.resources && data.resources.results && data.resources.results.products) || [], q);
        } catch (err) {
          if (err.name === 'AbortError') return;
          this.last = '';
          this.close();
          this.status.textContent = '';
        }
      }

      message(text) {
        const p = document.createElement('p');
        p.className = 'lf-search-bar__message';
        p.textContent = text;
        this.results.replaceChildren(p);
        this.open();
      }

      render(products, q) {
        if (!products.length) {
          this.message(this.dataset.empty);
          this.status.textContent = this.dataset.empty;
          return;
        }
        const list = document.createElement('ul');
        list.className = 'lf-search-bar__list';
        list.setAttribute('role', 'list');
        products.forEach((p) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'lf-search-bar__result';
          a.href = p.url;
          if (p.image) {
            const img = document.createElement('img');
            img.className = 'lf-search-bar__result-image';
            img.src = p.image;
            img.alt = '';
            img.width = 50;
            img.height = 50;
            img.loading = 'lazy';
            a.append(img);
          }
          const info = document.createElement('span');
          info.className = 'lf-search-bar__result-info';
          const title = document.createElement('span');
          title.className = 'lf-search-bar__result-title';
          title.textContent = p.title;
          info.append(title);
          const price = this.price(p.price);
          if (price) {
            const pr = document.createElement('span');
            pr.className = 'lf-search-bar__result-price';
            pr.textContent = price;
            info.append(pr);
          }
          a.append(info);
          li.append(a);
          list.append(li);
        });
        const all = document.createElement('a');
        all.className = 'lf-search-bar__view-all';
        all.href = this.dataset.searchUrl + '?q=' + encodeURIComponent(q);
        all.textContent = this.dataset.viewAll;
        this.results.replaceChildren(list, all);
        this.status.textContent = products.length + ' ' + this.dataset.count;
        this.open();
      }

      price(value) {
        const n = parseFloat(value);
        if (isNaN(n)) return '';
        try {
          return new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n);
        } catch (e) {
          return String(value);
        }
      }

      open() {
        this.results.hidden = false;
      }

      close() {
        this.results.hidden = true;
      }

      keydown(e) {
        if (e.key === 'Escape' && !this.results.hidden) {
          this.close();
          this.input.focus();
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        if (this.results.hidden) return;
        const links = Array.from(this.results.querySelectorAll('a'));
        if (!links.length) return;
        e.preventDefault();
        const i = links.indexOf(document.activeElement);
        const next = e.key === 'ArrowDown' ? i + 1 : i - 1;
        if (next < 0) {
          this.input.focus();
        } else {
          links[Math.min(next, links.length - 1)].focus();
        }
      }
    }
    customElements.define('lf-search-bar', LfSearchBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-sticky-cta')) {
    customElements.define('lf-sticky-cta', class extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.key;
        try { if (sessionStorage.getItem(this.key) === '1') { this.dataset.state = 'dismissed'; return; } } catch (e) {}
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        const close = this.querySelector('[data-lf-close]');
        if (close) close.addEventListener('click', () => this.dismiss());
        if (this.threshold > 0) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        }
      }
      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
      update() {
        if (this.dataset.state === 'dismissed') return;
        const shown = window.scrollY > this.threshold || this.contains(document.activeElement);
        this.dataset.state = shown ? 'shown' : 'hidden';
      }
      dismiss() {
        this.dataset.state = 'dismissed';
        try { sessionStorage.setItem(this.key, '1'); } catch (e) {}
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-store-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-lazy-widget')) {
    customElements.define('lf-lazy-widget', class extends HTMLElement {
      connectedCallback() {
        const load = () => {
          const src = this.dataset.src;
          if (!src || document.querySelector('script[src="' + src + '"]')) return;
          const s = document.createElement('script');
          s.src = src; s.async = true;
          document.head.appendChild(s);
        };
        if (!('IntersectionObserver' in window)) return load();
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-video-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-video-content')) {
    customElements.define('lf-video-content', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-lf-play]');
        const video = this.querySelector('video');
        if (btn) btn.addEventListener('click', () => this.play());
        if (video) {
          video.addEventListener('play', () => this.setAttribute('data-playing', ''));
          video.addEventListener('pause', () => this.removeAttribute('data-playing'));
          video.addEventListener('ended', () => this.removeAttribute('data-playing'));
        }
      }
      play() {
        const video = this.querySelector('video');
        if (video) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
          video.focus();
          return;
        }
        const tpl = this.querySelector('template[data-lf-embed]');
        const frame = this.querySelector('[data-lf-media]');
        if (!tpl || !frame) return;
        const iframe = tpl.content.firstElementChild.cloneNode(true);
        frame.replaceChildren(iframe);
        this.setAttribute('data-playing', '');
        iframe.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
